import script from "./txeOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./txeOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./txeOrderRecord.vue?vue&type=style&index=0&id=f087a1b4&lang=scss"

const __exports__ = script;

export default __exports__